import React from 'react'
import { CreateCustomShiftNotificationFlowProvider } from './context/CreateCustomShiftNotificationFlowProvider'
import { CreateCustomShiftNotificationFlowMain } from './components/CreateCustomShiftNotificationFlowMain'

export const CreateCustomShiftNotificationFlow = () => (
  <CreateCustomShiftNotificationFlowProvider>
    <CreateCustomShiftNotificationFlowMain />
  </CreateCustomShiftNotificationFlowProvider>
)
